import {css} from 'lit';
export const styles = css`:host(:not([selected])) {
  display: none;
}

:host([selected]) {
  display: block;
}

code-copy {
  display: flex;
  flex: 1;
}
`;
export default styles;
